import axiosInstance from './axios';

export const promoPackService = {
  getPromoPacks: async (params = {}) => {
    const response = await axiosInstance.get('/promo-packs', { params });
    return response.data;
  },

  getPromoPack: async (id) => {
    const response = await axiosInstance.get(`/promo-packs/${id}`);
    return response.data;
  },

  createPromoPack: async (promoPackData) => {
    const response = await axiosInstance.post('/promo-packs', promoPackData);
    return response.data;
  },

  updatePromoPack: async (id, promoPackData) => {
    const response = await axiosInstance.put(`/promo-packs/${id}`, promoPackData);
    return response.data;
  },

  deletePromoPack: async (id) => {
    const response = await axiosInstance.delete(`/promo-packs/${id}`);
    return response.data;
  },

  getPromoPackStatistics: async (id) => {
    const response = await axiosInstance.get(`/promo-packs/${id}/statistics`);
    return response.data;
  },
};
